import React from "react";

export const Logo = () => (
  <span className="flex mr-4 items-center">
    <svg
      version="1.1"
      x="0px"
      y="0px"
      viewBox="0 0 94.9 55.6"
      style={{ fill: "#FFFFFF", height: "24px" }}
    >
      <path
        className="st0"
        d="M89.9,12.1c-0.6-1.7-2.3-6.1-21.2-2C61.4,1.3,49-2.5,37.6,1.7S19.3,16.8,19.4,28.2C2.4,37.4,4,41.8,4.6,43.5
			c1.8,4.8,11.2,4.2,21.2,2c7.3,8.8,19.7,12.5,31,8.4C68.2,49.7,75.1,38.8,75,27.4C84.1,22.5,91.6,16.8,89.9,12.1z M10.8,41.3
			c1.1-1.3,3.8-3.6,9.5-6.8c0.2,1,0.5,2,0.9,2.9c0.4,1,0.8,1.9,1.2,2.8C16.6,41.4,12.6,41.6,10.8,41.3z M26.6,35.4
			c-4.2-11.4,1.6-24,13-28.2s24,1.6,28.2,13c0.5,1.3,0.8,2.5,1,3.8c-5.2,2.7-11.8,5.6-19.9,8.5c-8,3-15,5-20.7,6.4
			C27.7,37.9,27.1,36.7,26.6,35.4z M54.9,48.4c-8,2.9-16.6,0.9-22.5-4.4c8.2-2.2,15.8-4.9,18.6-5.9c2.9-1.1,10.4-3.9,18-7.6
			C68.1,38.4,62.8,45.5,54.9,48.4z M74.3,21.1c-0.2-1-0.5-2-0.9-2.9c-0.4-1-0.8-1.9-1.2-2.8c6.4-1.2,10-1.2,11.6-1
			C82.5,15.8,79.3,18.2,74.3,21.1z"
      />
      <ellipse className="st0" cx="35.2" cy="24.1" rx="4.5" ry="4.5" />
      <ellipse className="st0" cx="41.9" cy="14.3" rx="3.5" ry="3.5" />
      <ellipse className="st0" cx="45.8" cy="22.6" rx="3.2" ry="3.2" />
      <path
        className="st0"
        d="M7.1,25c0.3-0.2,0.7-0.2,1,0l2.6,1.5c1.1,0.6,2.4-0.3,2.2-1.6L12.3,22c-0.1-0.4,0-0.7,0.3-1l2.2-2
			c0.9-0.8,0.4-2.4-0.8-2.5l-3-0.3c-0.4,0-0.7-0.3-0.8-0.6L9,12.8c-0.5-1.1-2.1-1.1-2.7,0l-1.2,2.7c-0.1,0.3-0.5,0.6-0.8,0.6l-3,0.3
			c-1.2,0.1-1.7,1.7-0.8,2.5l2.2,2c0.3,0.2,0.4,0.6,0.3,1l-0.6,2.9c-0.3,1.3,1.1,2.3,2.1,1.6L7.1,25z"
      />
      <path
        className="st0"
        d="M94.5,33.7c0.9-0.8,0.4-2.4-0.8-2.5l-3-0.3c-0.4,0-0.7-0.3-0.8-0.6l-1.2-2.7c-0.5-1.1-2.1-1.1-2.7,0l-1.2,2.7
			c-0.1,0.3-0.5,0.6-0.8,0.6l-3,0.3c-1.2,0.1-1.7,1.7-0.8,2.5l2.2,2c0.3,0.2,0.4,0.6,0.3,1l-0.6,2.9c-0.3,1.2,1.1,2.2,2.2,1.6
			l2.6-1.5c0.3-0.2,0.7-0.2,1,0l2.6,1.5c1.1,0.6,2.4-0.3,2.2-1.6l-0.6-2.9c-0.1-0.4,0-0.7,0.3-1L94.5,33.7z"
      />
    </svg>
    <span className="flex ml-2 font-bold text-lg -mt-1">M.L.U.</span>
  </span>
);
